export default function App() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 max-w-4xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              随时随地 · 畅享漫画
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              女神漫画支持手机浏览器直接访问，无需下载安装。下拉式阅读完美适配移动端屏幕尺寸，通勤路上、午休间隙、睡前时光，打开浏览器就能立即畅享海量韩漫、日漫、国漫。高清画质、流畅滚动，给你桌面级阅读体验。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50 border border-background-200">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-smartphone-line"></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">手机浏览器</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50 border border-background-200">
                <span className="w-5 h-5 flex items-center justify-center text-secondary-500">
                  <i className="ri-tablet-line"></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">平板适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50 border border-background-200">
                <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-computer-line"></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">电脑端</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-56 h-96 md:w-64 md:h-[440px] rounded-2xl overflow-hidden border-4 border-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=A%20mobile%20phone%20screen%20mockup%20displaying%20a%20manga%20reading%20interface%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20abstract%20comic%20panel%20layout%20design%2C%20modern%20minimalist%20UI%2C%20no%20text%20no%20characters%2C%20clean%20mobile%20app%20style%20aesthetic&width=640&height=1280&seq=app-mobile-mockup&orientation=portrait"
                alt="女神漫画移动端阅读界面展示"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}